import React from "react";
import { Badge } from "@mantine/core";
import { PostAppointmentAttachmentSourceType } from "../../types/servicePostAppointment";

interface AttachmentBadgeProps {
  sourceType: PostAppointmentAttachmentSourceType;
  size?: "xs" | "sm" | "md";
}

const LABEL: Record<PostAppointmentAttachmentSourceType, string> = {
  template: "Standard",
  salon_template: "Custom",
  salon_document: "Document",
};

const COLOR: Record<PostAppointmentAttachmentSourceType, string> = {
  template: "teal",
  salon_template: "burntOrange",
  salon_document: "blue",
};

export const AttachmentBadge: React.FC<AttachmentBadgeProps> = ({
  sourceType,
  size = "xs",
}) => (
  <Badge size={size} variant="light" color={COLOR[sourceType]}>
    {LABEL[sourceType]}
  </Badge>
);

export default AttachmentBadge;
